// extracted by mini-css-extract-plugin
export default {"byCard__list":"styles_byCard__list__WD9Kc","byCard__title":"styles_byCard__title__A0Pwz","byCard__download":"styles_byCard__download__IQLjL"};